import React, { useEffect, useState } from 'react';
import { Alert, Input, Modal, Typography } from 'antd';
import { userMessageForError } from '../../utils/apiError';

const { Text } = Typography;

/**
 * A modal that cannot be confirmed without a written reason (reject an AI draft, retire a question).
 * The reason is sent to the API, which records it in the audit log (Commandment VI).
 * `onSubmit(reason)` must throw on failure; its message is shown through the shared apiError layer.
 */
const ReasonModal = ({ open, title, intro, reasonLabel = 'Reason (required)', okText, onSubmit, onClose }) => {
    const [reason, setReason] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) {
            setReason('');
            setError(null);
        }
    }, [open]);

    const submit = async () => {
        setBusy(true);
        setError(null);
        try {
            await onSubmit(reason.trim());
        } catch (err) {
            setError(userMessageForError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <Modal
            open={open}
            title={title}
            okText={okText}
            onOk={submit}
            onCancel={onClose}
            confirmLoading={busy}
            okButtonProps={{ disabled: !reason.trim() }}
        >
            {intro && <p style={{ marginTop: 0 }}>{intro}</p>}
            <Text strong>{reasonLabel}</Text>
            <Input.TextArea
                aria-label={reasonLabel}
                rows={3}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
            />
            {error && <Alert type="error" message={error} data-testid="reason-modal-error" style={{ marginTop: 12 }} />}
        </Modal>
    );
};

export default ReasonModal;
